module.exports = __webpack_public_path__ + "img/DE03282.c3f731f0.png";